<template>
  <div style="margin-top: 10px;">
    <div v-if="editing == true">
      <div>
        <span class="result-title">Shared Note:</span>
      </div>
      <div>
        <span style="color: rgb(128, 128, 128);">This note is a public, shared note. All users of the dictionary see and edit the same note.</span>
      </div>
      <textarea ref="textarea" class="notes-text-area" name="notes" rows="4" style="width: 100%; padding: 10px;" v-model="text">
      </textarea>
      <button class="add-note-done-button button" @click="finishEditing" style="margin-top: 5px;">Done</button>
    </div>
    <div v-else-if="text != '' && notesText != null" class="text">
      <div><span class="result-title">Shared Note:</span></div>
      <div class="notes-container" v-html="this.highlightedText"></div>
      <button @click="editNote" class="button"><font-awesome-icon icon="pencil-alt"/> Edit Note</button>
    </div>
    <div v-else-if="showCustomNotes">
      <span class="add-note-button" @click="addNote"><font-awesome-icon icon="plus"/> Add Note</span>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { mapState } from 'vuex'
  import Utils from '../utils'

  export default {
  name: 'ResultComponent',
  props: {
    notesText: String,
    title: String,
    entryId: Number,
    columnName: String,
    largerFont: {type: Boolean, value: false }
  },
    data() {
      return {
        editing: false,
        text: this.notesText
      }
    },
  computed: {
    ...mapState('app', [
      'searchText',
      'searchType',
      'allowEdits',
      'editToken',
      'showCustomNotes'
    ]),
    highlightedText() {
      const replaceNewlines = this.processNewLines(this.text);
      const resizeTibetan = replaceNewlines.replace(/[\u0F00-\u0FFF]+/g, (match) => {
        return '<span style="font-size:140%">'+match+"</span>";
      })
      return Utils.highlight(resizeTibetan, this.searchText, "highlight", this.searchType);
    }
  },
  methods: {
    processNewLines(input) {
      // eslint-disable-next-line no-control-regex
      return input.replace(/\n|\\n/g, "<br/>").replace(/།་/g, "། " );
    },
    addNote() {
      this.editing = true;
    },
    editNote() {
      this.editing = true;
      Vue.nextTick( () => {
        this.resizeTextArea();
      });
    },
    resizeTextArea() {
      this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight - 4 + 'px';
    },
    async finishEditing() {
      this.$log.debug(`Editing id=${this.entryId}, new note text = "${this.text}"`)
      await this.$server.dictionaryService.patch(this.entryId, {
        columnName: "notes",
        value:this.text,
        token: this.editToken,
        comment:"",
        user: ""
      });
      this.editing = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .result-title {
    font-weight: bold;
    margin-right:5px;
  }

  .largerfont {
    font-size: 160%;
    line-height: 80%;
  }

  .notes-text-area {
    background: 0;
    border-style:solid;
    border-width:1px;
  }

  .button {

    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
    float:right;
  }

  .add-note-button {
    border: 0;
    outline: 0;
    cursor: pointer;
    color: rgb(60, 66, 87);
    background-color: transparent;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    display: inline-block;
    min-height: 28px;
    transition: background-color .24s,box-shadow .24s;
    float:right;
  }

  button:hover {
    box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
  }

  .notes-container {
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 5px;
    background-color: rgba(125,125,125,0.1);
  }

</style>
